import { Property } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateProperty = (variables: Property) =>
  api.put({
    url: `/property/${variables.id}`,
    variables: omit(['id'], variables),
  });
